document.addEventListener('DOMContentLoaded', function() {
  var video = document.getElementById('hero-video');
  if (!video) return;

  // play em loop (já está no HTML, mas garantimos)
  video.play().catch(function(){});

  // clicar pausa / play
  video.addEventListener('click', function() {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });
});
